import React, { Fragment } from "react";

const TermsCondition = () => {
  return (
    <Fragment>
      <section id="contact" className="privacy">
        <div className="container pp-con">
          <div className="section-title-p wow fadeInUp" data-wow-delay="0.1s">
            <h2>Terms & Condition</h2>
          </div>

          <ul className="tc-l">
            <li>
              It's deemed that consignor /consignee has read all the terms &
              conditions and have agreed mutually before booking goods for
              transportation through us.
            </li>
            <li>Goods/Parcels are items handed over for transportation.</li>
            <li>Consignor is the sender of goods/Parcels.</li>
            <li>Consignee is receiver of goods/Parcels.</li>
            <li>
              Consignment note is receipt issued to consignor at the time of
              booking, and we the transporter is the entity that will transport
              goods/parcels.
            </li>
            <li>
              It is presumed that consignor has kept original invoice and other
              legal documents required for transportation within the goods.
            </li>
            <li>
              It is of consignor's & consignee's responsibility to properly and
              adequately pack goods required as per its type & nature. Kabra is
              not liable for any kind of leakage, breakage, pilferage and/or
              spoilage of goods.
            </li>
            <li>We don't support transportation of perishable goods.</li>
            <li>
              In Case of any transportation of perishable goods, Kabra would not
              be responsible for any loss/damage caused.
            </li>
            <li>
              We only support Branch to Branch and Branch-Door good Service.
            </li>
            <li>
              We transport all goods booked by us through road. We won't be
              responsible for any loss/damage occurred to consignor and/or
              consignee due to uncontrollable events such as riots, earthquake,
              theft, accident, fire, floods, etc. It's advisable to get marine
              insurance for goods/parcels.
            </li>
            <li>
              Delivery of goods shall be taken within three days after their
              arrival at delivery destination, failing which the
              consignee/consignor will be liable to pay additional demurrage
              charge (Demurrage refers to the charge that the merchant pays for
              the use of the container within the terminal beyond the free time
              period) at Rs.20/- per day per goods/parcels.
            </li>
            <li>
              If any Competent Govt. authority detains goods, we won't be
              responsible for the same and consignor/consignee shall indemnify
              us for any expenses, losses, damages suffered by the company.
              Consignor/consignee would be responsible to obtain all the permit
              required before booking and shall provide us requisite documents
              for transportation of goods.
            </li>
            <li>
              In the event of loss of consignment note goods might won't be
              delivered and consignor/consignee shall have no objection if the
              company delivers the goods directly to consignee on the basis
              consignment number or name of consignee as mentioned on
              consignment note.
            </li>
            <li>
              Consignor of the goods would be responsible to declare the actual
              value, and description of goods at the time of booking. We are not
              aware about the value, nature, type and description of goods given
              for transport.
            </li>
            <li>
              We at Kabra would be Liable for any kind of loss/damage/missing of
              goods. It is restricted to freight value charged on consignment
              note or Rs.500 whichever is less.
            </li>
            <li>
              We are not Transporting any goods which are prohibited by law in
              India, goods hazardous in nature and/or are dangerous to human
              life. Consignor shall not book any of such goods for transport and
              will be solely responsible.
            </li>
            <li>
              If the delivery is not taken from our warehouse within 15 days
              from the date of booking than we are not responsible for such
              goods and we have right to sell the goods to recover the total
              charges due as per consignment note.
            </li>
            <li>
              GST is applicable on total freight amount including other charges
              exceeding Rs.750 and its responsibility of the service receiver to
              pay tax as per reverse charge mechanism of section 9 (3) of
              CGST/SGST Act 2017.
            </li>
            <li>
              Any misinformation on consignment note shall be intimidated to our
              head office as soon as possible.
            </li>
            <li>
              Any complaint related to transportation of goods shall be
              communicated to our head office within seven days.
            </li>
            <li>Any dispute will be subject to Ahmedabad Jurisdiction.</li>
          </ul>
        </div>
      </section>
    </Fragment>
  );
};

export default TermsCondition;
